module.exports = __webpack_public_path__ + "static/media/bg_video.5ccf0982.jpg";